import { useState } from "react";
import { Tile, Chip } from "./Tile";

const describe = (r) => {
  if (!r.ready) return `waiting for ${r.source}`;
  const limit = r.min != null ? `${r.threshold} ${r.unit}` : r.unit;
  return [limit, r.note].filter(Boolean).join(" · ");
};

const RuleControls = ({ r, onSave }) => {
  const [t, setT] = useState(r.threshold == null ? "" : String(r.threshold));
  const [busy, setBusy] = useState(false);
  const run = async (body) => {
    setBusy(true);
    await onSave({ rule: r.id, ...body });
    setBusy(false);
  };
  return (
    <span className="flex shrink-0 items-center gap-1">
      {r.min != null && (
        <>
          <input data-testid={`rule-${r.id}-threshold`} type="number" min={r.min} max={r.max} value={t} onChange={(e) => setT(e.target.value)}
            title={`${r.min}-${r.max} ${r.unit}`} className="h-7 w-16 rounded-md border border-input bg-background px-1.5 text-right text-xs tabular-nums" />
          <button type="button" data-testid={`rule-${r.id}-save`} disabled={busy || t === "" || Number(t) === r.threshold} onClick={() => run({ threshold: Number(t) })}
            className="h-7 rounded-md bg-foreground px-2 text-[11px] font-semibold text-background transition-opacity hover:opacity-85 disabled:opacity-40">Save</button>
        </>
      )}
      {!r.email_locked && (
        <button type="button" data-testid={`rule-${r.id}-email-toggle`} disabled={busy} onClick={() => run({ email: !r.email })}
          className="h-7 rounded-md border border-border px-2 text-[11px] font-semibold transition-colors hover:bg-muted disabled:opacity-40">
          {r.email ? "Turn email off" : "Turn email on"}
        </button>
      )}
    </span>
  );
};

const RuleRow = ({ r, owner, onSave }) => (
  <li data-testid={`rule-${r.id}`} className={`border-b border-border/60 py-1.5 last:border-0 ${r.ready ? "" : "opacity-60"}`}>
    <div className="flex items-center gap-2">
      <span className={`h-2 w-2 shrink-0 rounded-full ${r.severity === "red" ? "bg-rose-500" : "bg-amber-400"}`} />
      <span className="min-w-0 truncate text-[13px] font-semibold">{r.label}</span>
      <Chip testid={`rule-${r.id}-email`} tone={r.ready && r.email && !r.email_locked ? "green" : undefined}>
        {!r.ready ? "not built yet" : r.email_locked ? "not emailed here" : r.email ? "email on" : "email off"}
      </Chip>
    </div>
    <div className="flex items-center gap-2 pl-4">
      <p data-testid={`rule-${r.id}-limit`} className="min-w-0 flex-1 truncate text-[11.5px] text-muted-foreground">{describe(r)}</p>
      {owner && r.ready && <RuleControls r={r} onSave={onSave} />}
    </div>
  </li>
);

export const AlertRulesTile = ({ rules, owner, onSave, index }) => (
  <Tile id="alerts-rules" index={index} kicker="Tile 9 · rules" title="Rules and thresholds"
    action={<Chip testid="alerts-rules-who" tone={owner ? "blue" : undefined}>{owner ? "You can change these (audited)" : "Owner changes these"}</Chip>}>
    <ul data-testid="alerts-rules" className="dash-scroll min-h-0 flex-1 overflow-y-auto pr-1">
      {rules.map((r) => <RuleRow key={`${r.id}-${r.threshold}-${r.email}`} r={r} owner={owner} onSave={onSave} />)}
    </ul>
  </Tile>
);
